<template>
  <div class="details">
     <van-nav-bar
      class="bar"
      title="退货单详情"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      :fixed="true"
    />
   <van-contact-card v-show="$route.query.id!=1" add-text='选择退货商品' type="add" @click="onAdd" />
   
   
    <div class="datails">
      <div class="top" >
        <div
          class="card "
          v-for="(v,i) in list"
          :key="i"
          @click="go(v)"
        >
        <van-swipe-cell>
          <van-card>
            <template #thumb>
              <img
                class="imgs"
                :src="v.sku_thumb"
                alt=""
              >
            </template>
            <template #title>
              <div class="title">{{v.name}}</div>
            </template>
            <template #price>
              <div class="price">￥{{v.goods_price}}</div>
            </template>
            
          </van-card>
          <div class="close">

           <van-stepper
                    
                      input-width="1.5rem"
                      button-size="0.75rem"
                      class="stepper"
                      @change="onChange(v)"
                      v-model="v.goods_num"
                      :max="v.max"
                      :disabled='v.zheng==1'
                    />
          </div>
          <!-- <template #right>
                  <van-button
                    square
                 
                    text="删除"
                    type="danger"
                    class="delete-button"
                    @click="delete_shop(v)"
                  />
                </template> -->
        </van-swipe-cell>
         <div class="v_field">
          <p>请描述具体问题情况：</p>

          <textarea
            v-model="v.txt"
            class="field"
            maxlength=45
            disabled
            placeholder="留言请在45字之内"
          ></textarea>
        </div>
        </div>
      </div>
      <!-- <div class="" v-show="list.length!=0" >
      <div class="num">
          <p>退货原因：</p>
          <span>产品质量问题</span>
          <div class="more">

          </div>
        </div>
     <div class="num"  @click="showPicker2 = true">
          <p>请选择业务经理：</p>
          <span>{{recommends}}</span>
          <div class="more">
<van-icon name="arrow" />
          </div>
        </div>
        <div class="shnagc">
            <p>请上传证据图片</p>
            <van-uploader
            max-size="113122150"
            accept="image/*"
            @oversize="oversize"
            :after-read="afterRead"
             @delete="san"
            v-model="fileList"
            max-count="5"
          />
        </div>
        </div> -->
      <div v-show="$route.query.id!=1" class="buts">

        <div class="but">
            
         
        <van-button
            color="#666"
            size="small"
            class="v_but"
            @click="ash"

          >放弃退出</van-button>
       
          <van-button
            color="#666"
            size="small"
            class="v_but"
            @click="ash2"

          >保存草稿</van-button>
            
            <van-button
            type="danger"
            size="small"
            class="v_but"
            @click="buy"
           
          >确认提交</van-button>
        </div>
      </div>
    </div>
   
 <van-popup
        v-model="showPicker2"
        position="bottom"
      >
        <van-picker
          show-toolbar
          :columns="columns2"
          @confirm="onConfirm2"
          @cancel="showPicker2 = false"
        />
      </van-popup>
  </div>
</template>
<script>
import Vue from 'vue'
import {
  NavBar,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Toast,
  Icon,
  Card, Stepper, Button, Field, Popup, Dialog,SwipeCell,AddressList,ContactCard,Uploader, Picker
} from 'vant'

Vue.use(NavBar)
  .use(GoodsAction)
  .use(GoodsActionButton)
  .use(GoodsActionIcon)
  .use(Toast).use(Icon)
  .use(Card)
  .use(Stepper)
  .use(Button).use(Field).use(Popup).use(Dialog).use(SwipeCell).use(AddressList).use(ContactCard).use(Uploader).use( Picker)
export default {
  created () {
    // this.actual_money=this.$route.params.id.actual_money
  // console.log(this.$store.state.tgood)
  this.$store.state.tgood.forEach(v => {
    v.goods.forEach(v1=>{
        this.list.push(v1)
    })
  });
   this.axios.get("getAllSalers/" + this.$store.state.shopid).then(res => {
        console.log(res)
        res.data.data.sale_info.forEach(v => {
          this.columns2.push(v.name)
          this.columns2id.push(v.id)
        })
      }).catch(ref => {
      })
  // this.list=this.$store.state.tgood
  },

  data () {
    return {
      address: { name: 'name', address: "address", tel: "mobile" },
      txt: 0,
      mobile: "",
      total_price:0,
      show:false,
      buy_goods:[],
      list:[],
      chosenAddressId:0,
      yshow:true,
      wb:'',
      show2:false,
      sn:'',
      yn:'',
      yt:'',
      fileList: [],
      columns2: [],
      columns2id: [],
recommends:'',
      showPicker2: false,

yz:[],
    }
  },
    computed: {
  
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    },
    onChange(){

    },
   onAdd() {
            this.$router.push('tui3')

    },
    go (v) {
      // console.log(this.$route.params.id.changjia)
      // return
      // if (this.$route.params.id.changjia == 1) {
      //   this.$router.push({ name: 'product', query: { id: v.goods_id, from: 1, c: 1 } })
      // } else {
      //   this.$router.push({ name: 'product', query: { id: v.goods_id, from: 1 } })
      // }
    },
    onConfirm2 (value, i) {
      this.recommends = value;
      this.recommendid = this.columns2id[i]
      this.showPicker2 = false;
    },
    buy(){
      if(this.list.length==0){
        return false
      }
      if(this.list[0].zheng==1){
this.axios.post('saveBackGoodsByEntirety', {
          // i.goods
          draft:0,
          backGoods:this.list,
          img:this.yz,
           order_sa_id:this.list[0].order_id,

          store_id: this.$store.state.shopid
        })
        .then((res) => {
          
           console.log(res)
          Toast(res.data.msg)
        })
        .catch((ref) => { })
      }else{

this.axios.post('saveBackGoodsByFrag', {
          // i.goods
          draft:0,
          backGoods:this.list,
          img:this.yz,
           order_sa_id:this.list[0].order_id,

          store_id: this.$store.state.shopid
        })
        .then((res) => {
          
           console.log(res)
          Toast(res.data.msg)
        })
        .catch((ref) => { })
      }

    },
    ash(){
this.$store.state.tgood=[]
this.list=[]
    },
    ash2(){
if(this.list.length==0){
        return false
      }
      if(this.list[0].zheng==1){
this.axios.post('saveBackGoodsByEntirety', {
          // i.goods
          draft:1,
          backGoods:this.list,
          img:this.yz,
           order_sa_id:this.list[0].order_id,
          store_id: this.$store.state.shopid
        })
        .then((res) => {
          
           console.log(res)
          Toast(res.data.msg)
        })
        .catch((ref) => { })
      }else{

this.axios.post('saveBackGoodsByFrag', {
          // i.goods
          draft:1,
          backGoods:this.list,
          img:this.yz,
           order_sa_id:this.list[0].order_id,

          store_id: this.$store.state.shopid
        })
        .then((res) => {
          
           console.log(res)
          Toast(res.data.msg)
        })
        .catch((ref) => { })
      }
    },
    delete_shop(v){
      if(v.zheng==1){
        Toast('整单退货不能修改哦')
        return false
      }
        let x
        this.list.forEach((s,i)=>{
            if(v.order_goods_id==s.order_goods_id){
                x=i
                this.list.splice(i,1)
            }
        })
    },
    oversize () {
      Toast('请上传10m之内的图片')

    },
     afterRead (file) {
      // 此时可以自行将文件上传至服务器
      // console.log(file)
      file.status = 'uploading';
      file.message = '上传中...';

      // setTimeout(() => {
      //   file.status = 'failed';
      //   file.message = '上传失败';
      // }, 1000)

      if (file.file.size > 11312215) {
        file.status = 'failed';
        file.message = '上传失败';
        Toast('请上传10m之内的图片')
        return
      }
      var formData = new FormData(); //构造一个 FormData，把后台需要发送的参数添加
      formData.append('image', file.file)
      console.log(1)
      this.axios.post('uploadCertificate', formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      }).then(res => {
        console.log(res)
        file.status = 'done';
        this.yz.push(res.data.path)

      }).catch(ref => {
        file.status = 'failed';
        file.message = '上传失败';
        console.log(ref)
      })

    },
     san(i,v){
      console.log(v)
      this.yz.splice(v.index,1)
    }
  }
}
</script>
<style lang="less" scoped>
.van-address-item__edit{
  top:-50%
}
.van-contact-card::before{
    position:relative
}
.delete-button{
    height: 100%;
}
.red{
  color: rgb(248, 58, 58);
  text-align: center;
  line-height: 1rem;
}
.details {
  padding-top: 1.2rem;
  padding-bottom: 1.2rem;
//   background-color: #f1f1f1;
}
.navt {
  width: 100%;
  position: fixed;
  top: 0;
}
.fp{
  line-height: 0.6rem;
  text-align: center;
  font-size: 0.38rem;
}
.fp1{
  padding-top: 0.5rem;
}
.address {
  position: relative;
  padding: 0.4rem;
  width: 100%;
  height: 2rem;
  background-color: #fefcee;
  .top {
    height: 0.76rem;
    .name {
      padding-right: 2rem;
      font-size: 0.426667rem;
    }
  }
  .bottom {
    font-size: 0.373333rem;
    color: #888;
  }
}
.cs {
  text-align: center;
  line-height: 1.3rem;
  color: red;
}
.dnum {
  font-size: 0.4rem;
  background-color: #fff;
  line-height: 0.8rem;
  padding-left: 0.3rem;
  span {
    color: #666;
  }
}
.shnagc{
    p{
      color: #757575;
      line-height: 1rem;
    }
      padding: 0.3rem 0.35rem;  

}
.datails {
//   margin-top: 0.266667rem;
  background-color: #fff;
  .shop {
    padding: 0.426667rem;
    color: #a22d2b;
    font-size: 0.426667rem;
    border-bottom: 0.03rem solid #dfdfdd;
  }
  .top {
    position: relative;
    background-color: #fff;
    width: 100%;
    // padding-bottom: 2.3rem;
    .card {
      border-bottom: 0.03rem solid #dfdfdd;
      .van-card {
        background-color: #fff;
        padding-bottom: 0;
      }

      width: 100%;
      position: relative;
      padding-top: 0.2rem;
    }
    .title {
      padding-top: 0.2rem;
      font-size: 0.34rem;
    }
    .imgs {
      width: 2rem;
      height: 2rem;
    }
    .price {
      color: #e02828;

      font-size: 0.5rem;
      padding-bottom: 0.64rem;
    }
    .close {
      text-align: right;
      font-size: 0.4rem;
      // color: #d3d;
      position: absolute;
      right: 5%;
      top: 60%;
      background-color: #fff;
    }

   
    .prices {
      padding: 0.35rem 0.5rem;
      text-align: right;
      .p_num {
        // font-size: 0.4rem;
        color: #666;
        span {
          // font-size: 0.48rem;
          color: #a22d28;
          // padding-right: 0.5rem;
        }
      }
    }
  }
   .num {
      border-bottom: 0.03rem solid #dfdfdd;
      color: #757575;
      padding: 0.3rem 0.35rem;
      display: flex;
      position: relative;
      span {
        text-align: right;
        width: 4rem;
        overflow: hidden; /*超过部分不显示*/
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 0.85rem;
        font-size: 0.35rem;
        padding-right: 10%;
      }
      p {
        line-height: 0.85rem;
        font-size: 0.35rem;
        flex: 1;
      }
      .stepper {
        flex: 1;
        text-align: right;
      }
      .more{
        line-height: 1.85;
        font-size: 0.45rem;
      }
    }
   
   .v_field {
      // border-bottom: 0.03rem solid #dfdfdd;
      color: #757575;
      padding: 0.3rem 0.35rem;
      p {
        line-height: 0.85rem;
        font-size: 0.35rem;
      }
      .field {
        background-color: #f1f1f1;
        width: 100%;
        border: none;
        height: 1.2rem;
        text-indent: 0.2rem;
        resize: none;
        padding-top: 0.2rem;
      }
    }
  .statistics {
    background-color: #dfdfdf;
    // margin-top: 1rem;
    height: 3.5rem;
    width: 100%;
    padding-top: 0.2rem;
    .num {
      border: none;
      padding: 0 0 0 0.3rem;
      background-color: #fff;
      span {
        color: #d0111b;
      }
    }
  }
  .buts {
    width: 100%;
    position: fixed;
    bottom: 0;
    border-top: 0.03rem solid #dfdfdf;
    background-color: #fff;
  }
  .but {
    display: flex;
    flex-direction: row-reverse;
    .v_but {
      width: 25%;
      margin: 0.2rem;
    }
  }
}
</style>